export default "__VITE_ASSET__897e0e8e__"